// YERİ: src/app/domains/site/sections/footer.section.ts
// Site footer — marka + hızlı bağlantılar + iletişim + sosyal + telif.

import { Component, computed, input, inject } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface FooterLink { label: string; url: string; }

@Component({
  selector: 'sec-footer',
  standalone: true,
  imports: [MIcon],
  template: `
    <footer class="text-neutral-300" style="background-color:var(--site-primary-dark)">
      <div class="mx-auto grid max-w-7xl gap-10 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div class="lg:col-span-2">
          <p class="font-[family-name:var(--site-head-font)] text-2xl font-bold text-white">{{ siteName() }}</p>
          <p class="mt-3 max-w-md text-sm leading-relaxed text-neutral-400">{{ tagline() }}</p>
          <div class="mt-5 flex gap-3">
            @for (s of socials(); track s.url) {
              <a [href]="s.url" class="flex size-9 items-center justify-center rounded-lg bg-white/10 transition hover:bg-white/20" [attr.aria-label]="s.label">
                <m-icon [name]="s.icon" size="sm" />
              </a>
            }
          </div>
        </div>
        <div>
          <h3 class="text-sm font-semibold uppercase tracking-wider text-white">{{ metin.t('links') }}</h3>
          <ul class="mt-4 space-y-2 text-sm">
            @for (l of links(); track l.url) {
              <li><a [href]="l.url" class="text-neutral-400 transition hover:text-white">{{ l.label }}</a></li>
            }
          </ul>
        </div>
        <div>
          <h3 class="text-sm font-semibold uppercase tracking-wider text-white">{{ metin.t('contact') }}</h3>
          <ul class="mt-4 space-y-2 text-sm text-neutral-400">
            @if (phone()) { <li>{{ phone() }}</li> }
            @if (email()) { <li>{{ email() }}</li> }
            @if (address()) { <li>{{ address() }}</li> }
          </ul>
        </div>
      </div>
      <div class="border-t border-white/10">
        <div class="mx-auto max-w-7xl px-6 py-5 text-center text-xs text-neutral-500 lg:px-8">{{ copyright() }}</div>
      </div>
    </footer>
  `,
})
export class FooterSection {
  /** Ziyaretçiye görünen kabuk metinleri — dil sitenin ayarından. */
  protected metin = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected siteName = computed(() => cfg(this.config(), 'siteName', 'Hukuk Bürosu'));
  protected tagline = computed(() => cfg(this.config(), 'tagline', 'Hukuki süreçlerinizde güvenilir, çözüm odaklı ve şeffaf danışmanlık.'));
  protected phone = computed(() => cfg(this.config(), 'phone', '+90 212 000 00 00'));
  protected email = computed(() => cfg(this.config(), 'email', 'info@hukukburosu.com'));
  protected address = computed(() => cfg(this.config(), 'address', 'Merkez Mah. Adalet Cad. No:1, İstanbul'));
  protected copyright = computed(() => cfg(this.config(), 'copyright', '© ' + '2026 Hukuk Bürosu. Tüm hakları saklıdır.'));
  protected links = computed<FooterLink[]>(() => cfg<FooterLink[]>(this.config(), 'links', [
    { label: 'Hakkımızda', url: '#about' },
    { label: 'Uygulama Alanları', url: '#practice' },
    { label: 'Ekibimiz', url: '#team' },
    { label: 'İletişim', url: '#contact' },
  ]));
  protected socials = computed<{ label: string; url: string; icon: string }[]>(() => cfg(this.config(), 'socials', [
    { label: 'LinkedIn', url: '#', icon: 'linkedin' },
    { label: 'Instagram', url: '#', icon: 'instagram' },
    { label: 'Twitter', url: '#', icon: 'twitter' },
  ]));
}
